import styled from "styled-components";

import Paper from "components/Layout/Paper";

import { COLORS } from "constants/colorScheme";

const CARD_HEIGHT = 120;

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  background-color: ${COLORS.WHITE};
  border-radius: 8px;
`;

export const ImageContainer = styled.div`
  min-width: 120px;
  min-height: ${CARD_HEIGHT}px;

  background-image: url(${({ image }: { image: string }) => image});
  background-size: cover;

  border-radius: 8px;
`;

export const DetailsContainer = styled(Paper)`
  display: flex;
  justify-content: center;

  height: ${CARD_HEIGHT}px;
  width: 100%;

  padding: 24px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleWrapper = styled.div`
  margin-bottom: 8px;
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ControlWrapper = styled.div`
  margin-right: 40px;
`;
